"use strict";

exports.__esModule = true;
exports.PlantStateFilterContext = void 0;
var _Utils = require("../../../Utils");
var _PlantStateFilterController = require("./PlantStateFilterController");
/**
 * Provides a configured PlantStateFilter to consumers.
 * @component
 */

var PlantStateFilterContext = exports.PlantStateFilterContext = (0, _Utils.createEnhancedContext)({
  propName: "plantStateFilter",
  defaultController: _PlantStateFilterController.PlantStateFilterController
});